import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Browse All Categories');

  const handleSelect = (cat: typeof categories[0]) => {
    setSelectedCategory(cat.name);
    setIsDropdownOpen(false);
    window.open(cat.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Browse by Category
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Explore thousands of spreadsheet products organized by category. Select a category below to start browsing on our main website.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10">
          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="w-full flex items-center justify-between px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-700 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <span>{selectedCategory}</span>
              <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </button>

            {isDropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-1 bg-background-50 border border-background-200 rounded-lg shadow-lg z-30 max-h-72 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat)}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors text-left cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="relative w-full h-24 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2 px-3 py-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}